/**
 * 为保证支持按需加载，务必使用 export default
 */
import { getUrlParamsWithoutDecode } from '../utils/index';
import { setCookie } from '../utils/cookie';
var cookieMap = {
  t: '__t',
  v: 'v',
  zlj_device_id: 'deviceId',
  zlj_device_name: 'deviceName',
  zlj_group_id: '',
  zlj_system_version: 'system',
  model: 'deviceName',
  PPU: 'PPU'
};
export default (function () {
  var params = getUrlParamsWithoutDecode({
    decode: true
  });

  for (var key in cookieMap) {
    var paramsKey = cookieMap[key];
    var currentValue = params[paramsKey];

    if (currentValue) {
      if (key === 'PPU') {
        currentValue = "\"".concat(currentValue, "\"");
      }

      setCookie(key, currentValue);
    }
  }

  setCookie('zlj_group_id', 13);
});